var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { setColor } from '../icon.utilities';
export function SAIconPlus(_a) {
    var size = _a.size, colorVariant = _a.colorVariant, onClick = _a.onClick, icon = _a.icon, theme = _a.theme, additionalProps = __rest(_a, ["size", "colorVariant", "onClick", "icon", "theme"]);
    var iconTheme = useContext(ThemeContext);
    var color = setColor(iconTheme, colorVariant, 'primary');
    var renderSize = size !== null && size !== void 0 ? size : '100px';
    return (React.createElement("svg", __assign({}, additionalProps, { width: renderSize, height: renderSize, viewBox: "0 0 18 18", version: "1.1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }),
        React.createElement("path", { d: "M9 3C9.41421 3 9.75 3.33579 9.75 3.75V8.25H14.25C14.6642 8.25 15 8.58579 15 9C15 9.41421 14.6642 9.75 14.25 9.75H9.75V14.25C9.75 14.6642 9.41421 15 9 15C8.58579 15 8.25 14.6642 8.25 14.25V9.75H3.75C3.33579 9.75 3 9.41421 3 9C3 8.58579 3.33579 8.25 3.75 8.25H8.25V3.75C8.25 3.33579 8.58579 3 9 3Z", fill: color })));
}
//# sourceMappingURL=icon.plus.component.js.map